(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const setCurrentLinks = (scope = document) => {
    const current = window.location.pathname.replace(/\/$/, '') || '/';
    scope.querySelectorAll('.v5-header a[href], .v5-footer a[href]').forEach((link) => {
      let path;
      try { path = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '') || '/'; } catch (_) { return; }
      if (path === current) link.setAttribute('aria-current', 'page');
    });
  };

  const initHeader = (scope = document) => {
    const header = scope.querySelector('[data-header]') || document.querySelector('[data-header]');
    const toggle = header?.querySelector('[data-nav-toggle]');
    const nav = header?.querySelector('[data-nav]');
    if (!header || !toggle || !nav || header.dataset.v5Bound) return;
    header.dataset.v5Bound = 'true';

    const closeAll = () => {
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('is-nav-open');
      header.querySelectorAll('.has-dropdown.is-open').forEach((item) => {
        item.classList.remove('is-open');
        item.querySelector(':scope > [data-dropdown-toggle]')?.setAttribute('aria-expanded', 'false');
      });
    };

    toggle.addEventListener('click', () => {
      requestAnimationFrame(() => document.body.classList.toggle('is-nav-open', nav.classList.contains('is-open')));
    });

    header.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      if (link && window.matchMedia('(max-width: 1120px)').matches) closeAll();
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) closeAll();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAll();
        toggle.focus({ preventScroll: true });
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 1120) closeAll();
    }, { passive: true });

    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  const initReveals = (scope = document) => {
    if (!document.body.classList.contains('has-editorial-motion')) return;
    const elements = scope.querySelectorAll('.v5-pathway, .v5-capability-row, .v5-process-step, .v5-proof-pillar, .v5-resource-tool');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-revealed'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { threshold: .12, rootMargin: '0px 0px -6% 0px' });
    elements.forEach((element, index) => {
      element.classList.add('v5-reveal');
      element.style.setProperty('--v5-reveal-delay', `${Math.min(index % 6, 5) * 45}ms`);
      observer.observe(element);
    });
  };

  const initAnalytics = (scope = document) => {
    scope.querySelectorAll('.v5-home-hero__path, .v5-pathway, .v5-resource-tool, .v5-nav-cta').forEach((link) => {
      if (link.dataset.v5Analytics) return;
      link.dataset.v5Analytics = 'true';
      link.addEventListener('click', () => {
        const detail = {
          event: 'biocorp_v5_navigation',
          label: link.textContent.trim().replace(/\s+/g, ' ').slice(0, 120),
          destination: link.getAttribute('href'),
          page: window.location.pathname
        };
        window.dispatchEvent(new CustomEvent('biocorp:v5:navigation', { detail }));
        if (Array.isArray(window.dataLayer)) window.dataLayer.push(detail);
      });
    });
  };

  const init = (scope = document) => {
    setCurrentLinks(scope);
    initHeader(scope);
    initReveals(scope);
    initAnalytics(scope);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
